import * as RGroup from '@radix-ui/react-radio-group'
import classNames from 'classnames'
import { ReactNode } from 'react'

interface RadioGroupItem {
  label: ReactNode
  value: string
}

interface Props extends RGroup.RadioGroupProps {
  items: RadioGroupItem[]
}

export function RadioGroup({ items, ...props }: Props) {
  return (
    <RGroup.Root
      {...props}
      className={classNames(props.className, 'space-y-5')}
    >
      {items.map(item => (
        <RGroup.Item
          key={item.value}
          value={item.value}
          className='flex items-center space-x-3 group'
        >
          <div className='flex h-5 w-5 items-center justify-center border-2 border-cool-400 rounded-full group-data-[state=checked]:border-cool-900 group-data-[state=checked]:bg-cool-900 group-hover:border-cool-900 transition-colors duration-150'>
            <RGroup.Indicator className='h-2 w-2 rounded-full bg-cool-50' />
          </div>
          <span className='text-base'>{item.label}</span>
        </RGroup.Item>
      ))}
    </RGroup.Root>
  )
}
